"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    item: {
        overflow: 'hidden',
        cursor: 'pointer',
        padding: '11px 10px',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        '&[data-is-active=true]': {
            backgroundColor: theme.indigoPastel3
        },
        '&[data-is-selected=true]': {
            color: theme.grey1
        },
        '& strong': {
            fontWeight: 'bold',
            color: theme.grey1
        }
    },
    prefix: {
        marginRight: 10
    }
});
//# sourceMappingURL=filteredItem.style.js.map